/** Mirrors backend ReportContentType (SadeceBilgisayar.DATA.Entities.Business). */
export enum ReportContentType {
  Profile = 0,
  Listing = 1,
  Reel = 2,
}
